import { render, staticRenderFns } from "./Cumulative.vue?vue&type=template&id=fd10aac8&scoped=true&"
import script from "./Cumulative.vue?vue&type=script&lang=js&"
export * from "./Cumulative.vue?vue&type=script&lang=js&"
import style0 from "./Cumulative.vue?vue&type=style&index=0&id=fd10aac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd10aac8",
  null
  
)

export default component.exports